import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { fetchAuthSession } from 'aws-amplify/auth';

import { API_URL } from '@/shared/redux/api/base-api';
import {
  TFilesBackupTreeRequest,
  TProjectTreeItemRequest,
  TProjectTreeRequest,
  TProjectTreeResponse,
} from '@/shared/redux/api/rendering/rendering-api.types';

export const renderingApi = createApi({
  reducerPath: 'renderingApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_URL}/rendering/v1`,
    prepareHeaders: async (headers) => {
      const session = await fetchAuthSession();
      const token = session?.tokens?.idToken?.toString();
      headers.set('Authorization', 'Bearer ' + token);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    startProjectTree: builder.mutation<
      TProjectTreeResponse,
      TProjectTreeRequest
    >({
      query: (request) => ({
        url: '/project-tree-async',
        method: 'POST',
        body: request,
      }),
    }),
    startFileBackupProjectTree: builder.mutation<
      TProjectTreeResponse,
      TFilesBackupTreeRequest
    >({
      query: (request) => ({
        url: '/files-backup-project-tree-async',
        method: 'POST',
        body: request,
      }),
    }),
    getProjectTreeJob: builder.query<TProjectTreeResponse, string>({
      query: (jobId) => `/rendering-job/${jobId}`,
    }),
    startProjectTreeItem: builder.mutation<
      TProjectTreeResponse,
      TProjectTreeItemRequest
    >({
      query: (request) => ({
        url: '/project-tree-item-async',
        method: 'POST',
        body: request,
      }),
    }),
    getProjectTreeItemJob: builder.query<TProjectTreeResponse, string>({
      query: (jobId) => `/rendering-job/${jobId}`,
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useStartProjectTreeMutation,
  useGetProjectTreeJobQuery,
  useStartProjectTreeItemMutation,
  useGetProjectTreeItemJobQuery,
  useStartFileBackupProjectTreeMutation,
} = renderingApi;
